<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
    <v-container class="text-center">
      <v-row>
        <v-col cols="12">
          <v-text-field
            filled
            data-cy="FormTask-name"
            :label="$$t('name')"
            v-model="localTask.name"
          />
        </v-col>
      </v-row>
      <!-- <v-row>
          <v-col cols="12">
            <v-text-field
              filled
              data-cy="FormTask-defaultValue"
              :label="$$t('defaultValue')"
              v-model="localTask.defaultValue"
            />
          </v-col>
        </v-row> -->
      <div class="d-flex justify-end mb-6">
        <v-btn
          color="default"
          outlined
          class="ml-4 btn-cancel"
          @click="cancel"
          data-cy="FormTask-button-cancel">
          {{ $t('common.buttons.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          type="submit"
          class="ml-4"
          data-cy="FormTask-button-save">
          {{ $t('common.buttons.save') }}
        </v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormTask',
  module: 'Tasks',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    Task: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localTask
      */
      localTask: {},
    };
  },
  watch: {
    Task() {
      this.localTask = this.Task;
    },
  },
  created() {
    this.localTask = this.Task;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localTask);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormTask example

'''js
<FormTask :Task="Task" />
'''
</docs>
